import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class CustomFieldOption extends DomainObject {
  value;

  constructor(other) {
    super();

    makeObservable(this, {
      value: observable
    });

    this.merge(other);
  }
}

export default CustomFieldOption;
